/**
 * Header search form toggle
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

const searchFormToggle = () => {
    const searchToggle = document.getElementById('searchform__toggle');
    if (!searchToggle) return;

    searchToggle.addEventListener('click', () => {
        const searchActive = document.body.classList.contains('searchActive');
        if (searchActive) {
            document.body.classList.remove('searchActive');
            searchToggle.setAttribute('aria-expanded', 'false');
        } else {
            document.body.classList.add('searchActive');
            searchToggle.setAttribute('aria-expanded', 'true');
        }
    });

    const searchClose = document.getElementById('searchform__close');
    if (!searchClose) return;

    searchClose.addEventListener('click', () => {
        const searchActive = document.body.classList.contains('searchActive');
        if (searchActive) {
            document.body.classList.remove('searchActive');
            searchToggle.setAttribute('aria-expanded', 'false');
        } else {
            document.body.classList.add('searchActive');
            searchToggle.setAttribute('aria-expanded', 'true');
        }
    });
};

export default searchFormToggle;
